import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 3.5rem;
	border: 1px solid;
	border-radius: 400px;
	padding: 0 var(--spacing-4);
	gap: 0.5rem;

	&.default {
		border-color: var(--blue-70);
		background-color: var(--blue-10);

		> .icon {
			color: var(--blue);
		}

		> button:hover > .icon {
			color: var(--blue-hover) !important;
		}
	}

	&.active {
		border-color: var(--green-70);
		background-color: var(--green-10);

		> .icon {
			color: var(--green);
		}

		> button:hover > .icon {
			color: var(--green-hover) !important;
		}
	}

	&.inprogress {
		border-color: var(--yellow-70);
		background-color: var(--yellow-10);

		> .icon {
			color: var(--yellow);
		}

		> button:hover > .icon {
			color: var(--yellow-hover) !important;
		}
	}

	&.inactive {
		border-color: var(--red-70);
		background-color: var(--red-10);

		> .icon {
			color: var(--red);
		}

		> button:hover > .icon {
			color: var(--red-hover) !important;
		}
	}

	&.disabled {
		border-color: var(--black-40);
		background-color: var(--black-10);

		> .icon {
			color: var(--black);
		}

		> button:hover > .icon {
			color: var(--black-hover) !important;
		}
	}

	> button {
		padding: 0 !important;

		:hover {
			background-color: transparent !important;
		}
	}

	@media ${Breakpoints.mobile} {
		height: 3rem;
	}
`;
